import { render, staticRenderFns } from "./Su1Surveys.vue?vue&type=template&id=f8355c90&scoped=true"
import script from "./Su1Surveys.vue?vue&type=script&lang=js"
export * from "./Su1Surveys.vue?vue&type=script&lang=js"
import style0 from "./Su1Surveys.vue?vue&type=style&index=0&id=f8355c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8355c90",
  null
  
)

export default component.exports